import React from 'react';
export function PainSection() {
  return <section className="border-b border-brand-line bg-white px-4 py-5" data-id="element-123" data-mp="1rruahoo2vtz4">
      <div className="mx-auto max-w-3xl space-y-4" data-id="element-124" data-mp="38wvk0gnqsznf">
        <article data-id="element-125" data-mp="38vkgmhy7ltwu">
          <h2 className="mb-1.5 text-center font-display text-[20px] leading-tight sm:text-3xl" data-id="element-126" data-mp="2uyfcwolyx74r">
            Stop guessing what&apos;s causing the diesel problem
          </h2>
          <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-127" data-mp="2z1ljxygwn2ca">
            Hard start or no-start? Low power, excessive smoke or boost problem? Fuel system,
            injectors, turbo, sensors, DPF… where do you test first?{' '}
            <span className="font-bold text-brand-carbon" data-id="element-128" data-mp="2bbhcfg0liig0">DIESEL DIAGNOSTIC PRO™</span> gives you
            an organized visual diagnostic system to help you move from symptom to possible cause
            with a clearer testing path.{' '}
            <span className="font-bold text-brand-carbon" data-id="element-129" data-mp="22buex5azlws8">Scan. Test. Isolate.</span>
          </p>
        </article>

        <article className="rounded-xl border-l-4 border-brand-yellow bg-brand-paper p-3 sm:p-4" data-id="element-130" data-mp="3rmr2vtz9ugzw">
          <h2 className="mb-1.5 font-display text-[18px] leading-tight sm:text-2xl" data-id="element-131" data-mp="3nlpanx3rv57f">
            😩 Stop diagnosing every diesel fault from scratch
          </h2>
          <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-132" data-mp="5dq5oiiedufx">
            You already know diesel repair. The problem is wasting time jumping between possible
            causes without a clear diagnostic sequence. Open the system, identify the symptom and
            follow the relevant tests.{' '}
            <span className="font-bold text-brand-carbon" data-id="element-133" data-mp="3im2ouz9vogn0">Less guessing. More structured diagnosis.</span>
          </p>
        </article>
      </div>
    </section>;
}